// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AdminResultadosRouteImport } from './routes/admin-resultados'
import { Route as AdminTicaRouteImport } from './routes/admin-tica'
import { Route as NicaAntierRouteImport } from './routes/nica-antier'
import { Route as NicaAyerRouteImport } from './routes/nica-ayer'
import { Route as NicaHoyRouteImport } from './routes/nica-hoy'
import { Route as NumeroSuerteRouteImport } from './routes/numero-suerte'
import { Route as QueSalioAyerEnLaNicaRouteImport } from './routes/que-salio-ayer-en-la-nica'
import { Route as QueSalioAyerEnTiemposJpsRouteImport } from './routes/que-salio-ayer-en-tiempos-jps'
import { Route as TicaAntierRouteImport } from './routes/tica-antier'
import { Route as TicaAyerRouteImport } from './routes/tica-ayer'
import { Route as TicaHoyRouteImport } from './routes/tica-hoy'
import { Route as TiemposNicaHoyRouteImport } from './routes/tiempos-nica-hoy'
import { Route as TiemposTicaHoyRouteImport } from './routes/tiempos-tica-hoy'
import { Route as ArticulosIndexRouteImport } from './routes/articulos.index'
import { Route as ArticulosSlugRouteImport } from './routes/articulos.$slug'
import { Route as ResultadosFechaRouteImport } from './routes/resultados.$fecha'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AdminResultadosRoute = AdminResultadosRouteImport.update({
            id: '/admin-resultados',path: '/admin-resultados',getParentRoute: () => rootRouteImport
          })
const AdminTicaRoute = AdminTicaRouteImport.update({
            id: '/admin-tica',path: '/admin-tica',getParentRoute: () => rootRouteImport
          })
const NicaAntierRoute = NicaAntierRouteImport.update({
            id: '/nica-antier',path: '/nica-antier',getParentRoute: () => rootRouteImport
          })
const NicaAyerRoute = NicaAyerRouteImport.update({
            id: '/nica-ayer',path: '/nica-ayer',getParentRoute: () => rootRouteImport
          })
const NicaHoyRoute = NicaHoyRouteImport.update({
            id: '/nica-hoy',path: '/nica-hoy',getParentRoute: () => rootRouteImport
          })
const NumeroSuerteRoute = NumeroSuerteRouteImport.update({
            id: '/numero-suerte',path: '/numero-suerte',getParentRoute: () => rootRouteImport
          })
const QueSalioAyerEnLaNicaRoute = QueSalioAyerEnLaNicaRouteImport.update({
            id: '/que-salio-ayer-en-la-nica',path: '/que-salio-ayer-en-la-nica',getParentRoute: () => rootRouteImport
          })
const QueSalioAyerEnTiemposJpsRoute = QueSalioAyerEnTiemposJpsRouteImport.update({
            id: '/que-salio-ayer-en-tiempos-jps',path: '/que-salio-ayer-en-tiempos-jps',getParentRoute: () => rootRouteImport
          })
const TicaAntierRoute = TicaAntierRouteImport.update({
            id: '/tica-antier',path: '/tica-antier',getParentRoute: () => rootRouteImport
          })
const TicaAyerRoute = TicaAyerRouteImport.update({
            id: '/tica-ayer',path: '/tica-ayer',getParentRoute: () => rootRouteImport
          })
const TicaHoyRoute = TicaHoyRouteImport.update({
            id: '/tica-hoy',path: '/tica-hoy',getParentRoute: () => rootRouteImport
          })
const TiemposNicaHoyRoute = TiemposNicaHoyRouteImport.update({
            id: '/tiempos-nica-hoy',path: '/tiempos-nica-hoy',getParentRoute: () => rootRouteImport
          })
const TiemposTicaHoyRoute = TiemposTicaHoyRouteImport.update({
            id: '/tiempos-tica-hoy',path: '/tiempos-tica-hoy',getParentRoute: () => rootRouteImport
          })
const ArticulosIndexRoute = ArticulosIndexRouteImport.update({
            id: '/articulos/',path: '/articulos/',getParentRoute: () => rootRouteImport
          })
const ArticulosSlugRoute = ArticulosSlugRouteImport.update({
            id: '/articulos/$slug',path: '/articulos/$slug',getParentRoute: () => rootRouteImport
          })
const ResultadosFechaRoute = ResultadosFechaRouteImport.update({
            id: '/resultados/$fecha',path: '/resultados/$fecha',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminLoginRoute: AdminLoginRoute,AdminResultadosRoute: AdminResultadosRoute,AdminTicaRoute: AdminTicaRoute,NicaAntierRoute: NicaAntierRoute,NicaAyerRoute: NicaAyerRoute,NicaHoyRoute: NicaHoyRoute,NumeroSuerteRoute: NumeroSuerteRoute,QueSalioAyerEnLaNicaRoute: QueSalioAyerEnLaNicaRoute,QueSalioAyerEnTiemposJpsRoute: QueSalioAyerEnTiemposJpsRoute,TicaAntierRoute: TicaAntierRoute,TicaAyerRoute: TicaAyerRoute,TicaHoyRoute: TicaHoyRoute,TiemposNicaHoyRoute: TiemposNicaHoyRoute,TiemposTicaHoyRoute: TiemposTicaHoyRoute,ArticulosSlugRoute: ArticulosSlugRoute,ResultadosFechaRoute: ResultadosFechaRoute,ArticulosIndexRoute: ArticulosIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)